<template>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label class="control-label" for="quickTemplatesCE">CE</label>
        <b-form-select
            id="quickTemplatesCE"
            v-model="selected"
            :options="availableTemplates"
            @input="onTemplateChange"
        ></b-form-select>
    </div>
</template>

<script>
export default {
    name: 'QuickTemplateCE',
    data() {
        return {
            selected: '',
            messageTemplate: "We have identified an issue affecting our {issue}, and our team is actively working to resolve it. We apologize for any inconvenience this may cause and appreciate your patience. We will keep you updated on our progress until the issue is fully resolved. Thank you for your understanding.",
            defaultConfig: { isScheduled: "0", isComponentDown: "1", sendEmail: "1" },
            templates: {
                campaign_ops: {
                    text: "Campaign Operations",
                    component: "Management"
                },
                builder: {
                    text: "Builder",
                    component: "Management"
                },
                ad_serving: {
                    text: "Ad Serving",
                    component: "Serving"
                },
                analytics: {
                    text: "Analytics",
                    component: "Management"
                }
            }
        }
    },
    computed: {
        availableTemplates() {
            return [
                { value: "", text: "Select a template..." },
                ...Object.keys(this.templates).map(key => ({
                    value: key,
                    text: this.templates[key].text
                }))
            ]
        }
    },
    methods: {
        onTemplateChange(value) {
            if (value && value !== "") {
                const template = this.templates[value]
                this.$emit('template-selected', {
                    message: this.messageTemplate.replace('{issue}', template.text),
                    component: template.component,
                    config: this.defaultConfig
                })
            } else {
                this.$emit('template-cleared')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/QuickTemplateCE.vue